import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import DashboardCard from '@components/pages/Dashboard/DasboardCard.component'
import DisplayCard from '@components/pages/Dashboard/PerformanceBoardPage/DisplaySummaryCard.component'
import ColumnChart from '@components/pages/Dashboard/Charts/ColumnChart.component'
import PieChart from '@components/pages/Dashboard/Charts/PieChart.component'
import CardContent from '@components/pages/Dashboard/CardContent.component'
import ChartTabs from '@components/pages/Dashboard/ChartTabs.component'
import { DashboardSummaryCard } from '@dataTypes/dashboard.types'
import {
  perfBoardCards,
  visitData,
  seriesNamesVisits,
  colors,
  cardLegendData,
  productiontColumnData,
  seriesNamesProduction,
  productiontLineData,
  cardLegendDataProd,
  seriesNamesLineProduction,
  colorsLine,
  unscheduledPatPC,
  unschedPatPCLegend,
  newPatientsLegend,
  hygieneReappointmentLegend,
  CancellationsLegend,
  noShowsLegend,
  restorativeCase,
  newPatients,
} from '@components/pages/Dashboard/DashboardMockData'
import ColumnLineCharts from '@components/pages/Dashboard/Charts/ColumnLineCharts.component'
import ProgressBarCardContent from '@components/pages/Dashboard/PerformanceBoardPage/ProgressBarCardContent.component'
import { VisitsModal } from '@components/layout/Modals'

function PerformanceBoard(): React.ReactElement {
  const [dashboardSummary] = useState<DashboardSummaryCard>(perfBoardCards)
  const [visitsModalIsOpen, setVisitsModalIsOpen] = useState(false)

  const toggleVisitModal = (): void => setVisitsModalIsOpen(!visitsModalIsOpen)
  const cardBodyVisits = [
    {
      content: (
        <ColumnChart
          title={'Total Visits'}
          data={visitData}
          seriesNames={seriesNamesVisits}
          colors={colors}
        />
      ),
      tabName: 'Total',
      eventKey: 'totalVisits',
    },
    {
      content: (
        <ColumnChart
          title={'Restorative Visits'}
          data={visitData}
          seriesNames={seriesNamesVisits}
          colors={colors}
        />
      ),
      tabName: 'Restorative',
      eventKey: 'restorativeVisits',
    },
    {
      content: (
        <ColumnChart
          title={'Hygiene Visits'}
          data={visitData}
          seriesNames={seriesNamesVisits}
          colors={colors}
        />
      ),
      tabName: 'Hygiene',
      eventKey: 'hygieneVisits',
    },
    {
      content: (
        <ColumnChart
          title={'Other Visits'}
          data={visitData}
          seriesNames={seriesNamesVisits}
          colors={colors}
        />
      ),
      tabName: 'Other',
      eventKey: 'otherVisits',
    },
  ]

  const cardBodyProduction = [
    {
      content: (
        <ColumnLineCharts
          title={'Total Production'}
          data={productiontColumnData}
          seriesNames={seriesNamesProduction}
          colors={colors}
          lineData={productiontLineData}
          lineColor={colorsLine}
          lineSeriesNames={seriesNamesLineProduction}
        />
      ),
      tabName: 'Total',
      eventKey: 'totalProduction',
    },
    {
      content: (
        <ColumnLineCharts
          title={'Restorative Production'}
          data={productiontColumnData}
          seriesNames={seriesNamesProduction}
          colors={colors}
          lineData={productiontLineData}
          lineColor={colorsLine}
          lineSeriesNames={seriesNamesLineProduction}
        />
      ),
      tabName: 'Restorative',
      eventKey: 'restorativeProduction',
    },
    {
      content: (
        <ColumnLineCharts
          title={'Hygiene Production'}
          data={productiontColumnData}
          seriesNames={seriesNamesProduction}
          colors={colors}
          lineData={productiontLineData}
          lineColor={colorsLine}
          lineSeriesNames={seriesNamesLineProduction}
        />
      ),
      tabName: 'Hygiene',
      eventKey: 'hygieneProduction',
    },
    {
      content: (
        <ColumnLineCharts
          title={'Other Production'}
          data={productiontColumnData}
          seriesNames={seriesNamesProduction}
          colors={colors}
          lineData={productiontLineData}
          lineColor={colorsLine}
          lineSeriesNames={seriesNamesLineProduction}
        />
      ),
      tabName: 'Other',
      eventKey: 'otherProduction',
    },
  ]

  return (
    <Row className="mt-2">
      <Col md={12}>
        <Row>
          {dashboardSummary &&
            dashboardSummary.map((item) => (
              <Col md={4} key={item.title}>
                <DashboardCard
                  title={item.title}
                  body={
                    <DisplayCard
                      displayText={item.activeCount}
                      trendDirection={item.trend}
                      showCurrencySymbol={false}
                    />
                  }
                  iconPrimary={'bi bi-bar-chart-fill'}
                  iconSecondary={'bi bi-search'}
                  classNameCard="h-100"
                />
              </Col>
            ))}
        </Row>
      </Col>
      <Col md={12}>
        <Row className="mt-5">
          <Col md={4}>
            <DashboardCard
              title={'Visits'}
              body={
                <CardContent
                  content={
                    <ChartTabs
                      tabs={cardBodyVisits}
                      defaultActiveKey={'totalVisits'}
                    />
                  }
                  legendData={cardLegendData}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
              onPrimaryIconClick={toggleVisitModal}
            />
          </Col>
          <Col md={4}>
            <DashboardCard
              title={'Production'}
              body={
                <CardContent
                  content={
                    <ChartTabs
                      tabs={cardBodyProduction}
                      defaultActiveKey={'totalProduction'}
                    />
                  }
                  legendData={cardLegendDataProd}
                  classNameCol={''}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
            />
          </Col>
          <Col md={4}>
            <DashboardCard
              title={'Unscheduled Patients'}
              body={
                <CardContent
                  content={
                    <PieChart
                      data={unscheduledPatPC}
                      title={'Unscheduled Patients'}
                      legendTitle="Months Since Last Visit"
                    />
                  }
                  legendData={unschedPatPCLegend}
                  classNameCol={'col-md-4'}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="down"
            />
          </Col>
        </Row>
      </Col>
      <Col md={12}>
        <Row className="mt-5">
          <Col md={4}>
            <DashboardCard
              title={'Restorative/Elective Case'}
              body={
                <ProgressBarCardContent
                  title={'Restorative/Elective Case'}
                  progLabel={'Avg/Exam - Goal'}
                  progUnit={'$'}
                  shouldShowSlider={true}
                  shouldDisplayFooter={true}
                  data={restorativeCase}
                  displayPercent={true}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
            />
          </Col>
          <Col md={4}>
            <DashboardCard
              title={'Hygiene Case'}
              body={
                <ProgressBarCardContent
                  title={'Hygiene Case'}
                  progLabel={'Avg/Visit - Goal'}
                  progUnit={'$'}
                  shouldShowSlider={true}
                  shouldDisplayFooter={true}
                  data={restorativeCase}
                  displayPercent={false}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
            />
          </Col>
          <Col md={4}>
            <DashboardCard
              title={'New Patients'}
              body={
                <ProgressBarCardContent
                  title={'New Patients'}
                  progUnit={'#'}
                  progLabel={'Goal'}
                  shouldShowSlider={true}
                  legendData={newPatientsLegend}
                  shouldDisplayFooter={false}
                  data={newPatients}
                  displayPercent={false}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
            />
          </Col>
        </Row>
      </Col>
      <Col md={12}>
        <Row className="mt-5">
          <Col md={4}>
            <DashboardCard
              title={'Hygiene Re-Appointment'}
              body={
                <ProgressBarCardContent
                  title={'Hygiene Re-Appointment'}
                  progUnit={'$'}
                  progLabel={'Goal'}
                  legendData={hygieneReappointmentLegend}
                  classNameCol={'col-md-4'}
                  data={restorativeCase}
                  displayPercent={true}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
            />
          </Col>
          <Col md={4}>
            <DashboardCard
              title={'Cancellations'}
              body={
                <ProgressBarCardContent
                  title={'Cancellations'}
                  progLabel={'Goal'}
                  progUnit={'$'}
                  legendData={CancellationsLegend}
                  classNameCol={'col-md-4'}
                  data={restorativeCase}
                  displayPercent={true}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
            />
          </Col>
          <Col md={4}>
            <DashboardCard
              title={'No-Shows'}
              body={
                <ProgressBarCardContent
                  title={'No-Shows'}
                  progLabel={'Goal'}
                  progUnit={'$'}
                  legendData={noShowsLegend}
                  classNameCol={'col-md-4'}
                  data={restorativeCase}
                  displayPercent={true}
                />
              }
              iconPrimary={'bi bi-bar-chart-fill'}
              iconSecondary={'bi bi-search'}
              classNameCard="h-100"
              trendDirection="up"
            />
          </Col>
        </Row>
      </Col>
      <VisitsModal
        title="Visits"
        toggleModal={toggleVisitModal}
        isOpen={visitsModalIsOpen}
      />
    </Row>
  )
}

export default PerformanceBoard
